import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  LinearProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const PRIMARY = "#286a94";

const ResumePreviewModal = ({
  open,
  onClose,
  fileUrl,
  fileName,
  uploading,
  progress,
}) => {
  if (!fileUrl) return null;

  const isDoc = fileUrl?.endsWith(".doc") || fileUrl?.endsWith(".docx");
  const previewUrl = isDoc
    ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        fileUrl
      )}`
    : fileUrl;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{ position: "relative", fontWeight: 600, color: PRIMARY }}
      >
        📄 {fileName || "Resume Preview"}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 10, top: 10 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* Show Upload Progress If Upload Is Active */}
        {uploading ? (
          <Box sx={{ p: 2, textAlign: "center" }}>
            <Typography sx={{ fontWeight: 600, mb: 1 }}>
              Uploading... {progress}%
            </Typography>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
        ) : (
          <Box
            sx={{
              height: "70vh",
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "#f4f6f8",
            }}
          >
            <iframe
              src={previewUrl}
              title="Resume Preview"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: "none" }}
              allowFullScreen={true}
              allow="fullscreen; clipboard-read; clipboard-write;"
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ResumePreviewModal;
